import { Text, type TextProps } from '@/ui';
import type { DecoratedEvent } from '../types';

type Props = TextProps & {
  location: DecoratedEvent['locationWithPlace'];
};

export const LocationText = ({ location, ...props }: Props) => {
  if (!location) {
    return null;
  }

  return (
    <Text
      overflowWrap="anywhere"
      {...(location.googlePlaceId &&
        location.name && {
          as: 'a',
          target: '_blank',
          textDecor: 'underline',
          href: `https://maps.google.com/maps?q=${encodeURIComponent(
            `place_id:${location.googlePlaceId}`
          )}`,
        })}
      {...props}
    >
      {location.name}
    </Text>
  );
};
